import { useEffect, useState } from "react";
import { lastRect } from "./PageAreaReporter";
import { PAGE_AREA } from "./page-area-events";

export default function usePageRect() {
  const [rect, setRect] = useState(lastRect);

  useEffect(() => {
    setRect(lastRect);

    function positionHandler(e) {
      setRect(e.detail);
    }

    document.addEventListener(PAGE_AREA, positionHandler);
    return () => {
      document.removeEventListener(PAGE_AREA, positionHandler);
    };
  }, []);

  return rect;
}
